module.exports = __webpack_public_path__ + "static/img/frog_ani.0a838fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/frog_ani.png
// module id = hAxp
// module chunks = 1 3